import styled from 'styled-components';
import { P } from 'components/Typography';
import { sizes } from 'style';

export const ButtonsContainer = styled.div`
  display: flex;
  margin-bottom: 35px;
  margin-top: 45px;
  width: 100%;
  padding-right: 0;

  > button {
    &:first-child {
      margin-left: auto;
      margin-right: 8px;
    }

    &:last-child {
      padding: 9px 25px;

      @media ${sizes.tabletPortrait} {
        padding: 9px 48px;
      }
    }
  }

  @media ${sizes.tabletPortrait} {
    align-self: end;
    justify-self: end;
  }

  @media ${sizes.tabletLandscape} {
    margin-bottom: 0;
    margin-top: 0;
  }
`;

export const Paragraph = styled(P)`
  margin-bottom: 6px;
  font-size: 16px;
`;
